import { render, staticRenderFns } from "./dashboard-news-modal.vue?vue&type=template&id=c59a4eb2&scoped=true"
import script from "./dashboard-news-modal.vue?vue&type=script&lang=js"
export * from "./dashboard-news-modal.vue?vue&type=script&lang=js"
import style0 from "./dashboard-news-modal.vue?vue&type=style&index=0&id=c59a4eb2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../.worktrees/accreditations-staging-e2e-fix/frontend/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c59a4eb2",
  null
  
)

export default component.exports